module.exports = __webpack_public_path__ + "static/mb-way_monei-7faf46c64f3ee97d843c95fd96317482.svg";